import TextButton from "@common/ui/TextButton"
import { Cross2Icon, CheckIcon } from "@radix-ui/react-icons"

type Props = {
  onConfirm: () => void
}

const Prompt = (props: Props) => {
  const { onConfirm } = props
  return (
    <div className="prompt">
      <TextButton
        color="secondary"
        className="bottom-controls-button"
        icon={<Cross2Icon height={20} width={20} color="#fff" />}
        style={{
          margin: 0,
          padding: "1em",
          width: "50%",
        }}
        onClick={() =>
          // @ts-ignore
          document.querySelector(".prompt").classList.toggle("active")
        }
      >
        No
      </TextButton>
      <TextButton
        color="secondary"
        className="bottom-controls-button"
        icon={<CheckIcon height={20} width={20} color="#fff" />}
        style={{
          margin: 0,
          padding: "1em",
          width: "50%",
          // backgroundColor: "#834848",
        }}
        onClick={onConfirm}
      >
        Yes
      </TextButton>
    </div>
  )
}

export default Prompt
